import React from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "@/components/app/AppShell";
import WorkQueueBoard from "@/components/app/WorkQueueBoard";
import { ClipboardList } from "lucide-react";

export default function AdminWorkQueue() {
  const nav = useNavigate();
  return (
    <AppShell>
      <div className="cq-in max-w-7xl">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.28em] font-black text-amber-600">
          <ClipboardList size={12} /> Team Work Queue
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900 mt-1">Who's up next</h1>
        <p className="text-slate-600 mt-1 max-w-2xl">
          Drag clients between columns. Every new signup auto-lands in <b>Queued</b>. Tap Open to jump straight into their credit file. Everything syncs live between you and Xzavier.
        </p>
        <div className="mt-6">
          <WorkQueueBoard
            kind="credit_report"
            emptyHint="New signups auto-appear here"
            onOpenClient={(item) => item.client_user_id && nav(`/admin/clients/${item.client_user_id}`)}
          />
        </div>
      </div>
    </AppShell>
  );
}
